export const DEFAULT_CAMERA_WIDTH = 1920
export const DEFAULT_CAMERA_HEIGHT = 1080

export const BASE_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
  facingMode: { exact: "environment" },
  width: { ideal: DEFAULT_CAMERA_WIDTH },
  height: { ideal: DEFAULT_CAMERA_HEIGHT },
}

export const getDeviceIdFromConstraints = (
  constraints: MediaTrackConstraints,
): string | null =>
  "deviceId" in constraints
    ? ((constraints.deviceId as ConstrainDOMStringParameters)
        ?.exact as string) ?? null
    : null

const DEVICE_AVAILABILITY_ERROR_NAMES = [
  "NotReadableError",
  "OverconstrainedError",
  "NotFoundError",
  "AbortError",
]

export const isDeviceAvailabilityError = (
  error: string | DOMException,
): error is DOMException =>
  error instanceof DOMException &&
  DEVICE_AVAILABILITY_ERROR_NAMES.includes(error.name)
